<template>
<div id="bo-mission-import-main">
  <bo-import title="Import de nouveaux utilisateurs"
             subtitle="Programme National"
             :columns="columns"
             :defaultRoles="['user','ghost']"
             routePrefix="spiadi"
             storePrefix="user">
  </bo-import>
</div>
</template>

<script>
import boImport from '@/components/boimport'

export default {
  name: 'mission-import',
  components: {
    'bo-import': boImport
  },
  data () {
    return {
      columns: [
        {
          field: 'name',
          name: 'Nom',
          mandatory: true
        },
        {
          field: 'firstName',
          name: 'Prénom',
          mandatory: true

        },
        {
          field: 'email',
          name: 'Emails',
          mandatory: true

        },
        {
          field: 'roles',
          name: 'Rôles',
          mandatory: false
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
